import { AlertTitle, Box, TableBody, TableCell, TableRow } from '@mui/material';
import Alert from '@mui/material/Alert';

import Props from './interface';

const ScrNotificationComponent: React.FC<Props> = ({
  alert,
  sx,
  component = 'div',
  children,
}) => {
  const alertDisplay = () => {
    const alertComponent = <AlertDisplayComponent alert={alert} />;

    return component === 'tbody' ? (
      <TableBody sx={sx}>
        <TableRow>
          <TableCell>{alertComponent}</TableCell>
        </TableRow>
      </TableBody>
    ) : (
      <Box sx={sx} component={component}>
        {alertComponent}
      </Box>
    );
  };

  return alert ? alertDisplay() : <>{children}</>;
};

const AlertDisplayComponent: React.FC<Props> = ({ alert }) => (
  <Alert severity={alert?.severity}>
    {alert?.title && <AlertTitle>{alert.title}</AlertTitle>}
    {alert?.message}
  </Alert>
);

export default ScrNotificationComponent;
